<template>
    <div class="m-update">
        <div class="title"></div>
        <div class="slogen"></div>

        <div class="m-version-parse">
            <div class="parse-content">
                <div class="update-img">
                    <div class="img"></div>
                </div>
                <div class="update-detail">
                    <transition name="slide-fade">
                        <div class="update-wrapper">
                            <div class="info">
                                <h6>{{ update_content[active].parsename }}</h6>
                                <div class="time">{{ update_content[active].time }}</div>
                            </div>

                            <div class="update-slogen">
                                {{ update_content[active].slogen }}
                            </div>

                            <div class="list">
                                <p>阶段内容：</p>
                                <div class="update-item" v-for="(item,index) in update_content[active].list" :key="index">
                                    <em class="icon i-index"></em>{{ item }}
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <div class="timeline">
                <div class="line">
                    <div class="line-bg"></div>
                </div>
                <ul>
                    <li v-for="(item,index) in update_content" :key="index">
                        <div class="status u-btn" :class="{'act' : active == index}" @click="active=index" v-if="index < 2"></div>
                        <div class="status u-btn" :class="{'act' : active == index}" @click="$toast('暂未开放')" v-else></div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="m-new-game-item">
            <div class="swiper_box">
                <div class="prev swiper-button u-btn" @click="clickPrev"></div>
                <div class="swiper_">
                    <swiper ref="updateSwiper"
                            :options="swiperOptions">
                        <!-- <swiper-slide class="item-device">
                            <div class="m-pet">
                                <div class="title-pet"></div>

                                <div class="pet-list">
                                    <div class="pet-item" v-for="(item,index) in pet_list" :key="index">

                                        <div class="pet-name">{{ item.petname }}</div>

                                        <div class="pic">
                                            <div class="pic-wrapper"
                                                @mouseover="$tips_on($event,item.id)"
                                                @mouseleave="$tips_off()"  
                                            >
                                                <game-item :id="item.id" :locked="true"></game-item>
                                            </div>                                           
                                        </div>

                                        <div class="pet-detail">
                                            <p v-for="(text,k) in item.detail" :key="k">{{ text }}</p>
                                        </div>

                                        <p class="notice">（加成效果请点击图片查看）</p>
                                    </div>
                                </div>
                            </div>
                        </swiper-slide> -->
                        <swiper-slide class="item-device">
                            <div class="m-inba">
                                <div class="titile-inba"></div>
                                <div class="img-inba">
                                    <a href="https://www.m3guo.com/activity/202207/inba-a629/" target="_blank" rel="noopener noreferrer"></a>
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide class="item-device">
                            <div class="m-c9">
                                <div class="titile-c9"></div>
                                <div class="img-c9"></div>
                            </div>                            
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="next swiper-button u-btn" @click="clickNext"></div>
            </div>
        </div>

        <!-- <a href="" class="u-btn more"></a> -->
    </div>
</template>

<style scoped>
.m-update{
    margin-top: 270px;
}

.title{
    position: relative;
    width: 556px;
    height: 180px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/title-3.png);
    z-index: 3;
}

.slogen{
    position: relative;
    width: 786px;
    height: 20px;
    margin: -30px auto 15px;
    background-image: url(~@/assets/images/pc/slogen-3.png); 
    z-index: 3;  
}

.m-version-parse{
    width: 1165px;
    margin: 0 auto;
}

.parse-content{
    display: flex;
    justify-content: space-between;
}

.update-img{
    position: relative;
    width: 594px;
    height: 372px;
    background-image: url(~@/assets/images/pc/update-img.png); 
}

.update-img .img{
    position: absolute;
    left: 21px;
    top: 19px;
    width: 552px;
    height: 330px;
    background-image: url(~@/assets/images/pc/update.jpg); 
}

.update-detail{
    position: relative;
    width: 592px;
    height: 370px;
    background-image: url(~@/assets/images/pc/bg-update_info.png);     
}

.timeline{
    position: relative;
    width: 737px;
    height: 18px;
    margin: 20px auto 0;
    overflow: hidden;
}

.timeline .line{
    width: 100%;
    height: 2px;
    position: absolute;
    top: 8px;
    left: 18px;
    z-index: 1;    
}

.line-bg{
    width: 100%;
    height: 2px;
    position: relative;
    overflow: hidden;
    z-index: 1;
    background-color: #f8f2d7;    
}

.timeline ul{
    width: 1304px;
    overflow: hidden;
    height: 18px;
    position: absolute;
    top: 0px;
    left: 0;
    transition: left 0.5s;
}

.timeline li{
    float: left;
    width: 180px;
    padding-top: 70px;
    line-height: 35px;
    text-align: center;
    position: relative;
    z-index: 1;   
}

.timeline .status{
    position: absolute;
    top: 0px;
    left: 1px;
    width: 16px;
    height: 16px;
    box-sizing: border-box;
    background-color: #141414;
    border: 1px solid #393935;
    border-radius: 50%;
}

.status::before{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 8px;
    height: 8px;
    margin: -4px 0 0 -4px;
    transform: scale(0);
    background-color: #8e0a0a;
    border-radius: 50%;
    transform-origin: center;
    transition: all .2s ease-in;
}

.status.act::before,
.status:hover::before{
    transform: scale(1);
}

.update-wrapper{
    padding: 40px 45px 0;
}

.update-detail .info{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 20px;
}

.update-detail h6{
    font-weight: 400;
    font-size: 24px;
    color: #c8b97f;
}

.update-detail .time{
    font-size: 16px;
    color: #92855f;
}

.update-detail .update-slogen{
    line-height: 1.8;
    font-size: 16px;
    color: #eceadc;
    padding-bottom: 16px;
    margin-bottom: 16px;
    border-bottom: 1px solid #92855f;
}

.update-detail .list{
    font-size: 16px;
    color: #eceadc;    
}

.list .i-index{
    display: inline-block;
    width: 14px;
    height: 14px;
    margin-right: 8px;
    background-image: url(~@/assets/images/pc/icon-index.png);
    vertical-align: middle;
}

.list .update-item{
    margin: 4px 0;
}

.m-new-game-item{
    position: relative;
    width: 1164px;
    height: 536px;
    margin: 60px auto 20px;
    background-image: url(~@/assets/images/pc/bg-update_swiper.png);
}

.m-new-game-item .prev{
    position: absolute;
    left: 40px;
    top: 50%;
    width: 44px;
    height: 35px;
    background-image: url(~@/assets/images/pc/btn-swiper_act.png);
    transform: translateY(-50%);
    z-index: 2;
}

.prev.swiper-button-disabled{
    background-image: url(~@/assets/images/pc/btn-swiper.png);
    transform: translateY(-50%) rotate(180deg);
}

.m-new-game-item .next{
    position: absolute;
    right: 40px;
    top: 50%;
    width: 44px;
    height: 35px;
    background-image: url(~@/assets/images/pc/btn-swiper_act.png);
    transform: translateY(-50%) rotate(180deg);
    z-index: 2;
}

.next.swiper-button-disabled{
    background-image: url(~@/assets/images/pc/btn-swiper.png);
    transform: translateY(-50%);
}

.swiper_box{
    padding: 42px 18px 0;
}

.title-pet{
    width: 1044px;
    height: 86px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/title-pet.png);
}

.pet-list{
    display: flex;
    padding: 0 112px;
    justify-content: space-between;
}

.pet-item{
    width: 288px;
    height: 328px;
    padding-top: 35px;
    text-align: center;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/pet-item.png);
}

.pet-name{
    margin-bottom: 40px;
    font-size: 20px;
    color: #d4cda9;
}

.pet-item>.pic{
    display: flex;
    width: 80px;
    height: 80px;
    margin: 0 auto 24px;
    background-color: #000;
    border: 3px solid #583924;
    justify-content: center;
    align-items: center;
}

.pet-item .pic-wrapper{
    width: 46px;
    height: 46px;
}

.pet-item .pet-detail p{
    margin-bottom: 6px;
    font-size: 14px;
    color: #c8b97f;
}

.pet-item .notice{
    font-size: 14px;
    color: #4f4938;    
}

.titile-inba{
    width: 1044px;
    height: 85px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/title-inba.png);    
}

.img-inba{
    width: 890px;
    height: 326px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/img-inba.jpg);      
}

.img-inba a{
    display: block;
    width: 100%;
    height: 100%;
}

.titile-c9{
    width: 1044px;
    height: 85px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/title-c9.png);    
}

.img-c9{
    width: 892px;
    height: 328px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/img-c9.png);      
}

.more{
    display: block;
    width: 321px;
    height: 77px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/btn-more.png);
}
</style>

<script>
export default {
    data (){
        return {
            active : 0,
            update_content : [
                {
                    img : '',
                    parsename : '壹●风云际会',
                    slogen : '论剑大会当天，众人纷纷向于吉发起挑战，然而变故突生，凡遇到于吉剑气之人皆会全身魔气萦绕而晕厥，徐庶以为是于吉对众人施加了魔毒，顺便也是一个挑战于吉的机会，便愤然起剑，隐世剑仙和天才剑客的对决开始了——',
                    time : '（7月8日开启）',
                    list : ['新英雄梦*刘禅','新关卡【守卫绝世神剑】和【华山寻宝】'],
                },
                {
                    img : '',
                    parsename : '贰●潜剑疑云',
                    slogen : '论剑大会当天，梦*马超见神皇一意孤行，于是趁机前往潜剑阁准备盗走神剑，但来到此处他发现周围一片狼藉，神剑早已不见，韩当跟踪梦*马超随后也来到了潜剑阁，并认为是他偷盗了神剑。于是二人在潜剑阁前对峙起来——',
                    time : '（待定）',
                    list : ['新关卡【守卫绝世神剑】和【华山寻宝】'],
                },
                {
                    img : '',
                    parsename : '阶段3',
                    slogen : '',
                    time : '（待定）',
                    list : [],
                },
                {
                    img : '',
                    parsename : '阶段4',
                    slogen : '',
                    time : '（待定）',
                    list : [],
                },
                {
                    img : '',
                    parsename : '阶段5',
                    slogen : '',
                    time : '（待定）',
                    list : [],
                },                                                                
            ],
            swiperOptions: {
                // slidesOffsetBefore: 10,
                // slidesOffsetAfter: 10,
                // slidesPerView: 'auto',
                // history: 'love',
                // 设置点击箭头
                navigation: {
                nextEl: '.next',
                prevEl: '.prev',
                },
            },
            pet_list : [
                {
                    petname : '乐天小常侍*战',
                    id : 'ZK43',
                    detail : ['+ 400.0攻击力','+ 15.0无视护甲'],
                },
                {
                    petname : '乐天小常侍*法',
                    id : 'ZK44',
                    detail : ['+145.0%技能加成','+9.5%法术穿透'],
                },
                {
                    petname : '乐天小常侍*盾',
                    id : 'ZK45',
                    detail : ['+35护甲','+100.0%法术防御','+ 4500.0生命值'],
                },                                 
            ],        
        }
    },
    computed: {
        swiper () {
        return this.$refs.mySwiper.swiper
        }
    },
    methods: {
        /* 前一步 */
        clickPrev () {
            const that = this
            const length = 3
            if (that.activeBtn <= 0 || length == 0) {
                return false
            }
        },
        /* 后一步 */
        clickNext () {
            const that = this
            const length = 3
            if (that.activeBtn >= length - 1 || length == 0) {
                return false
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/page/update.vue